<!--
 * @Autor: 黄旗
 * @Date: 2020-07-23 15:06:50
-->
<template>
    <div class="hqtodo">
        <el-row type="flex" align="middle" justify="space-between">
            <el-col :span="20">
                <el-select
                    style="width: 100px;"
                    v-model="params.type"
                    @change="askData"
                    placeholder="状态"
                >
                    <el-option label="全部" :value="3"></el-option>
                    <el-option label="待办" :value="1"></el-option>
                    <el-option label="已完成" :value="2"></el-option>
                </el-select>
            </el-col>
            <!-- <el-col :span="4"
                ><div
                    class="operation"
                    style="cursor: pointer;"
                    @click="delall"
                >
                    <i
                        style="color: #606266;"
                        class="el-icon-delete-solid"
                    ></i></div
            ></el-col> -->
        </el-row>
        <div class="hqtodos">
            <template v-for="(item,index) of tasklist">
                <el-row
                    class="elflex"
                    type="flex"
                    align="middle"
                    justify="space-between"
                >
                    <el-col :span="20">
                        <div v-if="item.show" @dblclick="shishiClick(item,index)">
                            <el-checkbox
                                v-model="item.choose"
                                @change="checkboxsub(item)"
                            ></el-checkbox>
                            <span
                                :class="`${item.choose ? 'hqtext' : ''}`"
                                >{{ item.task }}</span
                            >
                        </div>
                        <div class="input-ser input-sers" v-else>
                            <input
                                type="text"
                                :ref="`input_${index}`"
                                v-model="item.task"
                                placeholder="请完善待办事项"
                                @keyup.enter="submit(item)"
                            />
                        </div>
                    </el-col>
                    <el-col :span="4" v-if="!item.choose">
                        <div>
                            <el-dropdown @command="operationitem">
                                <span class="el-dropdown-link">
                                    <i
                                        style="color: #606266;"
                                        class="el-icon-more operation"
                                    ></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item
                                        :command="{ item, num: 'a', index }"
                                        >编辑</el-dropdown-item
                                    >
                                    <el-dropdown-item
                                        :command="{ item, num: 'b', index }"
                                        >删除</el-dropdown-item
                                    >
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </el-col>
                    <el-col :span="4" v-else>
                        <span class="deloperation" @click="delitem(item)"
                            >删除</span
                        >
                    </el-col>
                </el-row>
            </template>
        </div>
        <el-row
            class="elflexs"
            type="flex"
            align="middle"
            justify="space-between"
        >
            <el-col>
                <div class="input-ser">
                    <input
                        type="text"
                        placeholder="你今天想搞定什么？"
                        style="height:36px"
                        v-model="task"
                        @keyup.enter="submits"
                    />
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    name: "Todo",
    props: [],
    data() {
        return {
            value: true,
            values: true,
            params: { type: 1 },
            task: "",
            tasklist: [],
        };
    },
    mounted() {
        this.initial();
    },
    methods: {
        initial() {
            this.askData();
        },
        askData() {
            this.$http({
                method: "get",
                url: "/api/v1/todo/index",
                params: this.params,
            })
                .then((res) => {
                    // console.log(res.data.result);
                    this.tasklist = res.data.result;
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        submits() {
            this.$http({
                method: "post",
                url: "/api/v1/todo/create",
                data: { task: this.task },
            })
                .then((res) => {
                    this.$message({
                        message: "添加待办成功",
                        type: "success",
                    });
                    this.task = "";
                    this.askData();
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
        submit(item) {
            this.checkboxsub(item);
        },
        shishiClick(item,index) {
            for (let items of this.tasklist) {
                items.show = true
            }
            item.show = !item.show;
            this.$nextTick((x)=>{   //正确写法
                // console.log(11,this.$refs[`input_${index}`])
                this.$refs[`input_${index}`][0].focus();
            })
        },
        // delall() {
        //     this.$confirm("是否清除已完成信息?", "提示", {
        //         customClass: "hqdialog",
        //         confirmButtonText: "确定",
        //         cancelButtonText: "取消",
        //         type: "warning",
        //     })
        //         .then(() => {
        //             this.$message({
        //                 type: "success",
        //                 message: "删除成功!",
        //             });
        //         })
        //         .catch(() => {
        //             this.$message({
        //                 type: "info",
        //                 message: "已取消删除",
        //             });
        //         });
        // },
        operationitem(e) {
            if (e.num === "a") {
                for (let items of this.tasklist) {
                    items.show = true
                }
                e.item.show = !e.item.show;
                this.$nextTick((x)=>{   //正确写法
                    // console.log(11,this.$refs[`input_${e.index}`])
                    this.$refs[`input_${e.index}`][0].focus();
                })
            } else if (e.num === "b") {
                this.delitem(e.item);
            }
        },
        delitem(e) {
            let params = { id: e.id };
            this.$confirm("是否删除该条信息?", "提示", {
                customClass: "hqdialog",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$http({
                        method: "post",
                        url: "/api/v1/todo/delete",
                        data: params,
                    })
                        .then((res) => {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });
                            this.askData();
                        })
                        .catch((error) => {
                            // console.log(error);
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        checkboxsub(item, bool) {
            // console.log(item);
            let params = {
                id: item.id,
                status: item.choose ? 2 : 1,
                task: item.task,
            };
            this.$http({
                method: "post",
                url: "/api/v1/todo/update",
                data: params,
            })
                .then((res) => {
                    this.askData();
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
    },
};
</script>
<style>
.hqtodo ::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #fff;
}
.hqtodo :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #fff;
}
.hqtodo ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #fff;
}
.hqtodo :-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #fff;
}
.hqtodo input:focus::-webkit-input-placeholder {
    color: #fff;
}
.hqtodo {
    color: #fff;
}
.hqtodos {
    max-height: 300px;
    overflow: auto;
}
.hqtodos::-webkit-scrollbar-track {
    background-color: rgba(15, 15, 15, 0.925);
    border-radius: 15px;
}
.hqtodos::-webkit-scrollbar {
    width: 5px;
}
.hqtodos::-webkit-scrollbar-thumb {
    background-color: #444;
    border-radius: 5px;
}
.el-select-dropdown {
    border: 1px solid #333;
    background-color: #333;
}
.el-select .el-input__inner {
    background-color: rgba(0, 0, 0, 0);
    border-color: rgba(0, 0, 0, 0);
}
.el-select .el-input__inner:focus {
    border-color: rgba(0, 0, 0, 0);
}
.el-select .el-input.is-focus .el-input__inner {
    border-color: rgba(0, 0, 0, 0);
}
.el-select:hover .el-input__inner {
    border-color: rgba(0, 0, 0, 0);
}
.el-popper[x-placement^="bottom"] .popper__arrow::after {
    top: 1px;
    margin-left: -6px;
    border-top-width: 0;
    border-bottom-color: #fff;
    display: none;
}
.el-popper[x-placement^="bottom"] .popper__arrow {
    top: -6px;
    left: 50% !important;
    margin-right: 3px;
    border-top-width: 0;
    border-bottom-color: #333;
}
.el-popper[x-placement^="top"] .popper__arrow::after {
    bottom: none;
    margin-left: none;
    border-top-color: rgba(0, 0, 0, 0);
    border-bottom-width: none;
}
.el-select-dropdown__item {
    color: #fff;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
    background-color: #444;
}
.el-input__inner {
    color: #fff;
}
.el-popper[x-placement^="top"] .popper__arrow {
    left: 50% !important;
}
.operation {
    cursor: pointer;
    width: 25px;
    height: 25px;
    text-align: center;
    line-height: 25px;
    border-radius: 50%;
}
.operation:hover {
    background-color: #222;
}
.deloperation {
    padding: 5px 10px;
    font-size: 12px;
    text-align: center;
    background-color: #222;
    border-radius: 5px;
    cursor: pointer;
}
.elflex,
.elflexs {
    margin-top: 6px;
}
.elflex {
    padding-bottom: 6px;
    border-bottom: 1px solid #222;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #222;
    border-color: #fff;
}
.el-checkbox__inner:hover {
    border-color: #fff;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #fff;
}
.hqtext {
    color: #444;
    text-decoration: line-through;
}
.el-checkbox {
    color: #fff;
    margin-right: 5px;
}
.input-ser input {
    color: #afafaf;
    height: 30px;
    width: 100%;
    line-height: 29px;
    border-radius: 30px;
    box-sizing: border-box;
    padding: 1px 0 1px 20px;
    border: none;
    outline: none;
    background: rgba(0, 0, 0, 0.5);
}
.input-ser input::-webkit-input-placeholder{
    color:#444;
 }/*webkit 内核浏览器*/
.input-ser input::-moz-placeholder{
    color:#444;
}/*Mozilla Firefox 19+*/
.input-ser input:-moz-placeholder{
    color:#444;
}/*Mozilla Firefox 4 to 18*/
.input-ser input:-ms-input-placeholder{
    color:#444;
}
.input-ser input:focus::-webkit-input-placeholder{
    color:#444;
 }/*webkit 内核浏览器*/
.input-ser input:focus::-moz-placeholder{
    color:#444;
}/*Mozilla Firefox 19+*/
.input-ser input:focus:-moz-placeholder{
    color:#444;
}/*Mozilla Firefox 4 to 18*/
.input-ser input:focus:-ms-input-placeholder{
    color:#444;
}
.input-sers input {
    width: 90%;
}
.el-dropdown-menu {
    border: 1px solid #333;
    background-color: #333;
}
.el-dropdown-menu__item {
    color: #fff;
}
.el-dropdown-menu__item.hover,
.el-dropdown-menu__item:hover {
    background-color: #444;
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #444;
}
.hqdialog {
    background-color: rgba(15, 15, 15, 0.925);
    border: 1px solid rgba(15, 15, 15, 0.925);
}
.hqdialog .el-message-box__title,
.hqdialog .el-message-box__content,
.hqdialog .el-message-box__headerbtn .el-message-box__close {
    color: #fff;
}
.el-checkbox__inner{
    border: 1px solid #ffffff;
    background:rgba(15, 15, 15, 0.925)
}
</style>



// WEBPACK FOOTER //
// src/components/todo.vue